import axios from 'axios';

class Manager {
  constructor(curatorId) {
    this.baseUrl = process.env.APP_URL + `/users/curators/${curatorId}`;
  }

  getTherapists(perPage = 5, page = 1, search = '') {
    return axios.get(this.baseUrl + '/therapists', {
      params: {
        perPage,
        page,
        search,
      },
    });
  }

  deleteTherapist(id) {
    return axios.delete(`${this.baseUrl}/therapists/${id}`);
  }

  addTherapist(id) {
    let therapistIds = [id];
    return axios.post(`${this.baseUrl}/therapists`, {
      therapistIds,
    });
  }

  getNotOwnTherapists(perPage = 5, page = 1) {
    return axios.get(`${this.baseUrl}/therapists`, {
      params: {
        perPage,
        page,
        isOwn: 0,
      },
    });
  }
}

export default Manager;


// WEBPACK FOOTER //
// ./src/modules/user/curator/profile/api/Manager.js